import LinePlot from './LinePlot';
import BoxPlot from './BoxPlot';
import SimpleLinePlot from './SimpleLinePlot';

export {LinePlot, BoxPlot, SimpleLinePlot};

export default {
  LinePlot,
  BoxPlot,
  SimpleLinePlot,
};



// WEBPACK FOOTER //
// ./src/components/shared/plots/index.js